import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=a7937dd2&scoped=true&"
import script from "./particulars.vue?vue&type=script&lang=js&"
export * from "./particulars.vue?vue&type=script&lang=js&"
import style0 from "./particulars.vue?vue&type=style&index=0&id=a7937dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7937dd2",
  null
  
)

export default component.exports